import {initElement} from "./foreign.js";
const showMore = (node, v) => initElement(node);
export {showMore};
export * from "./foreign.js";
